import store from 'Store'
import i18n from '@/i18n'
import Nprogress from 'nprogress'
// helpers
import { networkErrorPage } from '../helpers'
import { Notification } from 'Utils/Classes/Notification'

// Preparing notifiaction
const notification = new Notification()
notification.message = 'Ha habido un error con el servidor'

// Prearing error handling
const apiErrorHandling = (error, next) => {
  if (error.response?.status === 404) {
    next({
      name: '404-resource',
      params: { resource: i18n.t('ui.error_page.resource.template') },
    })
  } else {
    next(networkErrorPage)
  }
}

// LISTING
export const loadTemplates = async (next) => {
  try {
    Nprogress.start()
    await store.dispatch('templates/loadAll')
    Nprogress.done()
    next()
  } catch (error) {
    Nprogress.done()
    apiErrorHandling(error, next)
  }
}

// SINGLE DETAILS
export const loadTemplateDetails = async (to, next) => {
  try {
    Nprogress.start()
    await store.dispatch('templates/loadPublishedTemplate', to.params.temp_id)
    Nprogress.done()
    next()
  } catch (error) {
    Nprogress.done()
    apiErrorHandling(error, next)
  }
}

// SINGLE EDIT
export const loadTemplateEdit = async (to, next) => {
  try {
    Nprogress.start()
    await store.dispatch('templates/loadTemplateDraft', to.params.temp_id)
    Nprogress.done()
    next()
  } catch (error) {
    Nprogress.done()
    apiErrorHandling(error, next)
  }
}
